export default async function getFromLocalStorage<V>(key: string): Promise<V> {
  const value = await localStorage.getItem(key);
  try {
    return JSON.parse(value);
  } catch (e) {
    return {} as V;
  }
}
